module.exports = __webpack_public_path__ + "1f65ca32bb28f6a09c0769c7b0fe8d71.png";